import { Routes } from '@angular/router';

import { AuthGuard } from '../../../guards/auth.guard';
import { HistoryComponent } from './history/history.component';
import { ProfileContainerComponent } from './profile-container/profile-container.component';


export const studentRoutes: Routes = [
  {
    path: 'student',
    canActivate: [],
    children: [
      {
        path: 'profile',
        component: ProfileContainerComponent,
      },
      {
        path: 'history',
        component: HistoryComponent,
      },
    ]
  },
];

